import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import styles from './FormFields.module.css';

export const ReactSelectInput = ({ defaultValues, formFieldStatus='checked', label = '', name, onChange, required = false, requiredIndicator = false, setFormFieldValidation, value, values}) => {

  const css = `
        .select__control--is-focused{
            border-color: #86b7fe !important;
            box-shadow: none !important;
        }
    `;

    const [inputValidation, setInputValidation] = useState({ isValid: null, msg: null });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleInputValidation = useCallback(() => {
        if(value.length > 0){
            setInputValidation({ isValid: true, msg: null });
            if(setFormFieldValidation) setFormFieldValidation(name, true);

        }else{
            if(required){
                setInputValidation({ isValid: false, msg: 'Selecciona al menos un elemento de la lista' });
                if(setFormFieldValidation) setFormFieldValidation(name, false);
            }else{
                setInputValidation({ isValid: true, msg: null });
                if(setFormFieldValidation) setFormFieldValidation(name, true);
            }
        }
    })

    const handleOnChange = (values) => {
        onChange({ target: { name: name, value: values.map(val => val.value) } });
    }

    useEffect(() => {
        handleInputValidation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])

    useEffect(() => {
        if(formFieldStatus === 'checking') handleInputValidation();
      }, [formFieldStatus, handleInputValidation]);
  
    return (
        <>
            <style>{ css }</style>
            {(label !== '') && <label htmlFor={ name } className={styles.customPreviewLabel}>{ label }{ requiredIndicator && <span className={styles.requiredIndicator}> *</span> }</label>}
            <Select
                defaultValue={defaultValues}
                isMulti
                name={name}
                onChange={handleOnChange}
                options={values}
                className={"basic-multi-select " + styles.basicMultiSelect}
                classNamePrefix="select"
            />
            <div className={styles.helperErrorTextReactSelect + ((inputValidation.isValid != null && !inputValidation.isValid) ? "" : " d-none" )}>{(inputValidation.isValid != null && !inputValidation.isValid) && inputValidation.msg}</div>
        </>
    )
}

ReactSelectInput.propTypes = {
    defaultValues: PropTypes.array.isRequired,
    formFieldStatus: PropTypes.oneOf(['checked', 'checking']),
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    requiredIndicator: PropTypes.bool,
    setFormFieldValidation: PropTypes.func,
    value: PropTypes.array.isRequired,
    values: PropTypes.array.isRequired,
}